import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectorRef, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HeaderService } from '../../../header/header.service';
import { SystemNotificationActionResponse, SystemNotificationItem, SystemNotificationResponse } from './system-message-popup.model';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-system-message-popup',
    templateUrl: './system-message-popup.component.html',
    styleUrls: ['./system-message-popup.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SystemMessagePopupComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();
  @Output('visibility-change') visibilityChange = new EventEmitter<boolean>();

  activeSysMsgData: SystemNotificationItem[] = [];
  selectedSysMsgData: Partial<SystemNotificationItem> = {};
  checkNotif: number = 0;
  minimise: boolean = true;
  showPopover: boolean = false;

  private isInitialized = false;
  private GENERAL_CONFIG: any = {};
  private USER_SETTINGS: any = {};

  @Input('header-data')
  set _headerData(headerData: string) {
    if (!headerData) return;
    try {
      const header = safeJsonInput<any>(headerData, null, 'system-message-popup.parse1');
      if (!header || Object.keys(header).length === 0) return;
      this.USER_SETTINGS = header.userSettingsData || {};
      this.GENERAL_CONFIG = header.generalConfigData || {};
      if (this.USER_SETTINGS?.user) {
        this.tryInit();
      }
    } catch (e) {
      console.log('Header data input not yet stable.');
    }
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private headerService: HeaderService
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.visibilityChange.emit(false);
  }

  private get adminBaseUrl(): string {
    return this.GENERAL_CONFIG.admin_api_url || this.GENERAL_CONFIG.admin_url || '/admin';
  }

  private tryInit(): void {
    if (!this.GENERAL_CONFIG || !this.USER_SETTINGS?.user) return;
    if (this.isInitialized) return;
    this.isInitialized = true;
    this.getSystemNotification();
  }

  private emitVisibility(): void {
    this.visibilityChange.emit(this.activeSysMsgData.length > 0);
  }

  private isCallSuccess(response: Partial<SystemNotificationResponse> | null | undefined): boolean {
    return response?.callSuccess == 1;
  }

  private parseNotifBody(item: Partial<SystemNotificationItem>): void {
    if (!item?.notif_msg_body || typeof item.notif_msg_body !== 'string') return;
    const parsed = safeJsonInput<unknown>(item.notif_msg_body, null, 'system-message-popup.notifBody');
    if (typeof parsed === 'string') {
      item.notif_msg_body = parsed;
    }
  }

  getSystemNotification(): void {
    const user = this.USER_SETTINGS?.user;
    if (!user) return;

    const data = {
      sso_id: user.sso_id,
      client_key: user.client_key,
      user_type: user.client?.user_type_key
    };

    this.headerService.getSystemNotifByUser(this.adminBaseUrl, { data }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: SystemNotificationResponse) => {
        if (this.isCallSuccess(response)) {
          this.activeSysMsgData = response.notif_list || [];
          if (this.activeSysMsgData.length > 0) {
            this.selectedSysMsgData = this.activeSysMsgData[0];
            this.parseNotifBody(this.selectedSysMsgData);
          } else {
            this.selectedSysMsgData = {};
          }
          this.emitVisibility();
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading system notifications:', error);
      }
    );
  }

  get notificationBodyHtml(): string {
    return String(this.selectedSysMsgData?.notif_msg_body || '');
  }

  cancelNotifModal(): void {
    this.activeSysMsgData = [];
    this.selectedSysMsgData = {};
    this.emitVisibility();
    this.cdr.detectChanges();
  }

  private buildDontShowPayload(): { sys_notif_key: number | string; sso_id: any; client_key: any } | null {
    const user = this.USER_SETTINGS?.user;
    if (!user) return null;
    if (this.selectedSysMsgData.notif_msg_key === undefined || this.selectedSysMsgData.notif_msg_key === null) {
      return null;
    }

    return {
      sys_notif_key: this.selectedSysMsgData.notif_msg_key,
      sso_id: user.sso_id,
      client_key: user.client_key
    };
  }

  notifCong(): void {
    if (this.checkNotif !== 1) return;

    const data = this.buildDontShowPayload();
    // Match expected UX: checkbox behaves like close (hide immediately),
    // and API persistence runs in background.
    this.minimise = true;
    this.cancelNotifModal();
    this.checkNotif = 0;

    if (!data) {
      return;
    }

    this.headerService.saveSystemDontShowMsg(this.adminBaseUrl, data).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: SystemNotificationActionResponse) => {
        if (!this.isCallSuccess(response)) {
          console.warn('saveDontShowSysMsg did not return callSuccess=1', response);
        }
      },
      (error: any) => {
        console.error('Error saving notification preference:', error);
      }
    );
  }

  selectSysNotif(selectedItem: SystemNotificationItem): void {
    this.selectedSysMsgData = selectedItem;
    this.parseNotifBody(this.selectedSysMsgData);
    this.showPopover = false;
    this.cdr.detectChanges();
  }

  togglePopover(): void {
    this.showPopover = !this.showPopover;
  }
}
